import React, { useState, useEffect } from 'react';
import TextTransition, { presets } from 'react-text-transition';

const TEXTS = [
  'restaurante',
  'pizzería',
  'cafetería',
  'hotel',
];

const HeroSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() =>
      setIndex(index => index + 1),
      1500);
    return (() => clearInterval(intervalId));
  });

  const data = {
    heading: 'Llevá tu',
    businesses: TEXTS,
    headingText: 'Transformá tu negocio con nuestra plataforma digital',
    buttonText: 'Empezá ahora',
    buttonTextTwo: 'Saber más',
  };

  return (
    <section
      id="home"
      className="section welcome-area bg-overlay d-flex align-items-center"
      style={{ minHeight: '100vh', padding: '4rem 0' }}
    >
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-12 col-lg-6 order-2 order-lg-1">
            <div className="welcome-intro" style={{
              marginTop: '2rem',
              padding: '0 1rem'
            }}>
              <h1 className="text-white" style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>
                {data.heading}
                <TextTransition
                  text={data.businesses[index % data.businesses.length]}
                  springConfig={presets.stiff}
                />
                al siguiente nivel.
              </h1>
              <p className="text-white my-4" style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                {data.headingText}
              </p>
              <div className="button-group d-flex flex-column flex-lg-row" style={{ marginTop: '2rem', gap: '1rem' }}>
                <a
                  href="#pricing"
                  className="hero-btn-primary scroll"
                  style={{
                    backgroundColor: '#F9B900',
                    color: 'white',
                    border: 'none',
                    padding: '12px 30px',
                    borderRadius: '30px',
                    boxShadow: '0 4px 15px rgba(44, 62, 80, 0.3)',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                  }}
                >
                  {data.buttonText}
                </a>
                <a
                  href="#features"
                  className="hero-btn-secondary scroll"
                  style={{
                    backgroundColor: '#FFF',
                    color: '#F9B900',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    padding: '12px 30px',
                    borderRadius: '30px',
                    backdropFilter: 'blur(5px)',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                  }}
                >
                  {data.buttonTextTwo}
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6 hero-prom order-1 order-lg-2" style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '2rem 1rem'
          }}>
            <img
              src="img/hero-prom.png"
              className="hero-prom-img"
              style={{
                maxWidth: '100%',
                height: 'auto',
                maxHeight: '400px',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>
      </div>
      {/* Shape Bottom */}
      <div className="shape-bottom">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
        >
          <path
            className="shape-fill"
            fill="#FFFFFF"
            d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7  c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4  c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
